// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-page {
  max-width: 900px;
  margin: 0 auto;
}

.quiz-page h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

.quiz-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.quiz-header h1 {
  margin: 0;
}

.quiz-progress {
  background: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
}

.previous-attempts {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  margin: 1rem 0;
}

.previous-attempts h3 {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
}

.btn-large {
  padding: 1rem 2rem;
  font-size: 1.125rem;
}

.questions-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.question-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.question-number {
  color: #3498db;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.question-text {
  font-size: 1.125rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-wrap;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.option-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.option-label:hover {
  background: #f8f9fa;
  border-color: #3498db;
}

.option-label input[type="radio"] {
  margin-top: 0.25rem;
  cursor: pointer;
}

.option-label span {
  flex: 1 1;
  white-space: pre-wrap;
}

.fill-blank-input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  font-size: 1rem;
}

.fill-blank-input:focus {
  outline: none;
  border-color: #3498db;
}

.quiz-actions {
  text-align: center;
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.warning-text {
  margin-top: 1rem;
  color: #e74c3c;
  font-weight: 500;
}

.quiz-completed-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.submit-confirmation-backdrop {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(4px);
  animation: confirmation-fade-in 0.16s ease-out;
}

.submit-confirmation-modal {
  width: min(100%, 440px);
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);
  text-align: center;
  animation: confirmation-rise-in 0.2s ease-out;
}

.confirmation-icon {
  display: grid;
  width: 3.25rem;
  height: 3.25rem;
  margin: 0 auto 1rem;
  place-items: center;
  border-radius: 50%;
  background: #eaf5ff;
  color: #2476b8;
  font-size: 1.5rem;
  font-weight: 700;
}

.submit-confirmation-modal h2 {
  margin: 0 0 0.65rem;
  color: #243449;
  font-size: 1.4rem;
}

.submit-confirmation-modal > p {
  margin: 0;
  color: #64748b;
  line-height: 1.6;
}

.confirmation-actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.6rem;
}

.confirmation-actions .btn {
  min-height: 44px;
}

@keyframes confirmation-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes confirmation-rise-in {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 480px) {
  .submit-confirmation-modal {
    padding: 1.5rem 1.25rem;
  }

  .confirmation-actions {
    flex-direction: column-reverse;
  }

  .confirmation-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/student/QuizPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".quiz-page {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.quiz-page h1 {\r\n  margin-bottom: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.quiz-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.quiz-header h1 {\r\n  margin: 0;\r\n}\r\n\r\n.quiz-progress {\r\n  background: #3498db;\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.previous-attempts {\r\n  background: #f8f9fa;\r\n  padding: 1rem;\r\n  border-radius: 4px;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.previous-attempts h3 {\r\n  margin: 0 0 0.5rem 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.btn-large {\r\n  padding: 1rem 2rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.questions-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.question-card {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.question-number {\r\n  color: #3498db;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.question-text {\r\n  font-size: 1.125rem;\r\n  color: #2c3e50;\r\n  margin-bottom: 1rem;\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.options-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.option-label {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.option-label:hover {\r\n  background: #f8f9fa;\r\n  border-color: #3498db;\r\n}\r\n\r\n.option-label input[type=\"radio\"] {\r\n  margin-top: 0.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.option-label span {\r\n  flex: 1;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.fill-blank-input {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.fill-blank-input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.quiz-actions {\r\n  text-align: center;\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.warning-text {\r\n  margin-top: 1rem;\r\n  color: #e74c3c;\r\n  font-weight: 500;\r\n}\r\n\r\n.quiz-completed-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.submit-confirmation-backdrop {\r\n  position: fixed;\r\n  z-index: 1000;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.25rem;\r\n  background: rgba(15, 23, 42, 0.58);\r\n  backdrop-filter: blur(4px);\r\n  animation: confirmation-fade-in 0.16s ease-out;\r\n}\r\n\r\n.submit-confirmation-modal {\r\n  width: min(100%, 440px);\r\n  padding: 2rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.75);\r\n  border-radius: 18px;\r\n  background: #fff;\r\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);\r\n  text-align: center;\r\n  animation: confirmation-rise-in 0.2s ease-out;\r\n}\r\n\r\n.confirmation-icon {\r\n  display: grid;\r\n  width: 3.25rem;\r\n  height: 3.25rem;\r\n  margin: 0 auto 1rem;\r\n  place-items: center;\r\n  border-radius: 50%;\r\n  background: #eaf5ff;\r\n  color: #2476b8;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.submit-confirmation-modal h2 {\r\n  margin: 0 0 0.65rem;\r\n  color: #243449;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.submit-confirmation-modal > p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  line-height: 1.6;\r\n}\r\n\r\n.confirmation-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-top: 1.6rem;\r\n}\r\n\r\n.confirmation-actions .btn {\r\n  min-height: 44px;\r\n}\r\n\r\n@keyframes confirmation-fade-in {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes confirmation-rise-in {\r\n  from { opacity: 0; transform: translateY(10px) scale(0.98); }\r\n  to { opacity: 1; transform: translateY(0) scale(1); }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .submit-confirmation-modal {\r\n    padding: 1.5rem 1.25rem;\r\n  }\r\n\r\n  .confirmation-actions {\r\n    flex-direction: column-reverse;\r\n  }\r\n\r\n  .confirmation-actions .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
